import Login from './components/User/Login';
import IndexDashboard from './components/Dashboard/indexDashboard';
import MobileApp from "./components/MobileApp/MobileApp";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Monitoring from './components/Common/monitor';
import Matching from './components/Matching/Matching'
import ContractGrid from './components/gridTemplate/contractGrid'
import ProjectGrid from './components/gridTemplate/projectGrid'
import ContactGrid from './components/gridTemplate/contactGrid'
import DataMGT from './components/Transaction/DataMGT'
import DataLoader from './components/DataLoading/DataLoader';
import Templates from './components/Templates/indexTemplates';
import TemplateIndex from 'components/Templates/TemplateIndex';
import MetaDataMainUI from 'components/MetaData/MetaDataMainUI';
import Reports from 'components/Reports/Reports';
import QuarterRun from 'components/Mechanical/quarterRun';
import SuggestedPayment from 'components/Payment/SuggestedPayment';
import DirectoriesIndex from 'components/directories/directoriesIndex';
import AssetCompareIndex from './components/MetaData/AssetPortal/AssetCompareIndex';


declare global {
  var period: any; var selectedContact: any; var portalLogo: any; var periodSelected: any;
  var periodCount: any; var currectPeriod: any; var lookUpTypeList: any; var tagColor: any; var ClientDSP: any;
  var systemFormatsList: any; var containers: any; var themeCustomization: any; var loadlabelList: any;
  var clientDetail: any; var tipaltiFix: any; var tipalTiRespond: any; var panelName: any; var runTimmer: any; var cueSheetType: any
    ; var statusProduct: any; var statusProductExt: any
}


console.log("truuuuuu")
function App() {

  if (window.sessionStorage.getItem('loggedUserRight')) {

    return (

      <BrowserRouter basename='/'>
        <Routes>
          <Route path='/' element={<IndexDashboard open="true" />} />
          <Route path='/directories/' element={<DirectoriesIndex pathname={"Directories"} />} />
          <Route path='/mobileApp' element={<MobileApp />} />
          <Route path='/monitoring' element={<Monitoring />} />
          <Route path='/matching' element={<Matching />} />
          <Route path='/contracts/' element={<ContractGrid />} />
          <Route path='/projects/' element={<ProjectGrid />} />
          <Route path='/contacts/' element={<ContactGrid />} />
          <Route path='/Transaction/' element={<DataMGT />} />
          <Route path='/Uploader/' element={<DataLoader />} />
          <Route path='/Templates/' element={<Templates />} />
          <Route path='/CreateTemplates/' element={<TemplateIndex />} />
          <Route path='/production/' element={<MetaDataMainUI />} />
          <Route path='/assetCompare/' element={<AssetCompareIndex />} />
          <Route path='/Reports/' element={<Reports />} />
          <Route path='/Mechanicals/' element={<QuarterRun />} />
          <Route path='/Payments/' element={<SuggestedPayment />} /> 
        </Routes>
      </BrowserRouter>

    );
  } else {
    return (<Login />);
  }
}

export default App;